export interface WorkshopService {
    id: number;
    icon: string;
    image: string;
    titleKey: string;
    descKey: string;
    link: string;
    cardDesc: { pt: string; en: string };
}

export const workshopServices: WorkshopService[] = [
    {
        id: 1,
        icon: 'icon-tire',
        image: '/assets/logo/services/alignment.webp',
        titleKey: 'alignment',
        descKey: 'alignmentDesc',
        link: '/oficina/alinhamento',
        cardDesc: {
            pt: 'Direção certa e pneus que duram mais.',
            en: 'Straight steering and tyres that last longer.'
        }
    },
    {
        id: 2,
        icon: 'icon-car',
        image: '/assets/logo/services/diagnostic_test.webp',
        titleKey: 'diagnosticTest',
        descKey: 'diagnosticTestDesc',
        link: '/oficina/teste-diagnostico',
        cardDesc: {
            pt: 'Leitura eletrónica de avarias e luzes no painel.',
            en: 'Electronic reading of faults and dashboard lights.'
        }
    },
    {
        id: 3,
        icon: 'icon-mechanical',
        image: '/assets/logo/services/roady_review.webp',
        titleKey: 'roadyReview',
        descKey: 'roadyReviewDesc',
        link: '/oficina/revisoes-roady',
        cardDesc: {
            pt: 'Revisão completa segundo o plano do fabricante, sem perder a garantia.',
            en: 'Complete service following the manufacturer\'s plan, without losing the warranty.'
        }
    },
    {
        id: 4,
        icon: 'icon-tyre',
        image: '/assets/logo/services/shock_absorbers.webp',
        titleKey: 'shockAbsorbers',
        descKey: 'shockAbsorbersDesc',
        link: '/oficina/amortecedores',
        cardDesc: {
            pt: 'Estabilidade e conforto em estrada.',
            en: 'Stability and comfort on the road.'
        }
    },
    {
        id: 5,
        icon: 'icon-car-wash',
        image: '/assets/logo/services/inspection.webp',
        titleKey: 'inspection',
        descKey: 'inspectionDesc',
        link: '/oficina/inspecao',
        cardDesc: {
            pt: 'Preparação do carro para a inspeção periódica.',
            en: 'Preparing the car for the periodic inspection.'
        }
    },
    {
        id: 6,
        icon: 'icon-mechanical',
        image: '/assets/logo/services/general_mechanics.webp',
        titleKey: 'generalMechanics',
        descKey: 'generalMechanicsDesc',
        link: '/oficina/mecanica-geral',
        cardDesc: {
            pt: 'Reparação de avarias mecânicas do dia a dia.',
            en: 'Repair of everyday mechanical faults.'
        }
    },
    {
        id: 7,
        icon: 'icon-oil',
        image: '/assets/logo/services/service_pack.webp',
        titleKey: 'workshopServices',
        descKey: 'workshopServicesDesc',
        link: '/oficina/servicos-oficina',
        cardDesc: {
            pt: 'Vários serviços do seu carro numa só visita.',
            en: 'Several services for your car in a single visit.'
        }
    },
    {
        id: 8,
        icon: 'icon-fan',
        image: '/assets/logo/services/air_conditioning.webp',
        titleKey: 'airConditioning',
        descKey: 'airConditioningDesc',
        link: '/oficina/ar-condicionado',
        cardDesc: {
            pt: 'Carregamento e manutenção do ar condicionado.',
            en: 'Air conditioning recharge and maintenance.'
        }
    },
    {
        id: 9,
        icon: 'icon-tools',
        image: '/assets/logo/services/washing.webp',
        titleKey: 'washing',
        descKey: 'washingDesc',
        link: '/oficina/lavagem',
        cardDesc: {
            pt: 'Lavagem interior e exterior do seu carro.',
            en: 'Interior and exterior washing of your car.'
        }
    },
    {
        id: 10,
        icon: 'icon-low-beam',
        image: '/assets/logo/services/headlight_restoration.webp',
        titleKey: 'headlightRestoration',
        descKey: 'headlightRestorationDesc',
        link: '/oficina/restauro-farois',
        cardDesc: {
            pt: 'Faróis baços de volta à transparência.',
            en: 'Dull headlights back to transparency.'
        }
    },
    {
        id: 11,
        icon: 'icon-battery',
        image: '/assets/logo/services/batteries.webp',
        titleKey: 'batteries',
        descKey: 'batteriesDesc',
        link: '/oficina/baterias',
        cardDesc: {
            pt: 'Teste e substituição da bateria.',
            en: 'Battery testing and replacement.'
        }
    },
    {
        id: 12,
        icon: 'icon-brake',
        image: '/assets/logo/services/brakes.webp',
        titleKey: 'brakes',
        descKey: 'brakesDesc',
        link: '/oficina/travoes',
        cardDesc: {
            pt: 'Verificação e substituição de pastilhas e discos.',
            en: 'Checking and replacing pads and discs.'
        }
    }
];

